import { TextInput, SelectInput, required } from 'react-admin';
import { DefaultToolbar } from '@/components/toolbars';
import { CandidateEditStatusProps } from '../types';
import useController from './useController';

const FormContent = (props: CandidateEditStatusProps) => {
  const { actions, handleClose, handleSave } = useController(props);
  return (
    <>
      <SelectInput
        id="edit-status-select"
        choices={actions}
        label="Select a new state"
        optionValue="name"
        source="action"
        validate={required()}
      />
      <TextInput source="note" label="Add a note" validate={required()} />

      <DefaultToolbar onClose={handleClose} onSave={handleSave} />
    </>
  );
};

export default FormContent;
